module.exports = __webpack_public_path__ + "d9a95285e0bcf8dfbc8acc2d4edb6436.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/jeans.png
// module id = 1869
// module chunks = 0